import OperationsFindMyTruck from "../../components/Operations/FindMyTruck/OperationsFindMyTruck";

const OperationsFindMyTruckPage = () => {
  return <OperationsFindMyTruck />;
};

export default OperationsFindMyTruckPage;
